<script setup>
import { storeToRefs } from 'pinia'
import { useMessageStore } from '~/stores/messages'

// Fetch messages
const messagesStore = useMessageStore()
const { messages: staticKeys } = storeToRefs(messagesStore)

// Track user click
const trackPaymentButton = () => {
    trackUserClick({
        eventName: TRACKING_CONSTANTS.CLICK_EVENTS.PARKING_HOME_CLICK,
        button: TRACKING_CONSTANTS.MISC.PARKING_PAYMENT
    })
}

const paymentButtonConfig = computed(() => {
    return {
        buttonType: 'primary',
        type: 'internal',
        link: 'centerUid-parking-payTicket',
        large: true,
        active: true,
        fn: () => trackPaymentButton()
    }
})
</script>

<template>
    <div class="parking-payment-action-cta">
        <BaseButton :base-button-config="paymentButtonConfig">
            {{ staticKeys?.parkingfirstpage_ticket_payment_cta }}
        </BaseButton>
    </div>
</template>

<style lang="scss">
.parking-payment-action-cta {
    margin-block-end: px2rem(40);
    display: flex;
    justify-content: center;

    @include content-grid;

    @include bp(large1) {
        display: none;
    }

    a {
        grid-column: 1 / -1;
        grid-row: 1;

        @include bp(medium1) {
            grid-column: 3 / 7;
        }
    }
}
</style>
